<template>
  <div id="page-user-view pt-20">
    <div id="user-data">
      <vx-card title="Guarantor Information">


        <vx-card title="Personal Information" class="mb-base">
          <!-- Avatar -->
          <div class="vx-row">

            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col">
              <div class="img-container mb-4">
                <!--          <img :src="user_data.avatar" class="rounded w-full" />-->
              </div>
            </div>
            <!-- Information - Col 1 -->
            <div class="vx-col flex-1" id="account-info-col-1">
              <table>
                <tr>
                  <td class="font-semibold">Name</td>
                  <td>{{ guarantor.name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Father’s Name</td>
                  <td>{{ personal.father_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Mother’s Name</td>
                  <td>{{ personal.mother_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Spouse Name</td>
                  <td>{{ personal.spouse_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Age</td>
                  <td>{{ personal.age }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Marital Status</td>
                  <td>{{ personal.marital_status }}</td>
                </tr>


              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div v-if="personal !== null" class="vx-col flex-1" id="account-info-col-2">
              <table>
                <tr>
                  <td class="font-semibold">Gender</td>
                  <td>{{ personal.gender }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Head of Household</td>
                  <td>{{ personal.head_of_household }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Education Level</td>
                  <td>{{ personal.education_level }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">NID No</td>
                  <td>{{ personal.nid }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Relationship</td>
                  <td>{{ guarantor.relationship }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 2 -->
          </div>
          <div v-if="personal !== null" class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button  color="success" class="mr-3 mb-2 float-right" size="small" @click="updatePersonalInfo(guarantor.id)">Edit Personal Information </vs-button>

            </div>
          </div>
        </vx-card>
        <vx-card v-if="contact !== null" title="Contact Information">
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Mobile</td>
                <td> {{ guarantor.phone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Other Phone</td>
                <td> {{ contact.other_phone||'' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td> {{ contact.email ||''}}</td>
              </tr>
            </table>
          </div>
          <br>
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <vx-card title="Present Address" class="mb-base">
                <table>
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>{{ presentAddress.division }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>{{ presentAddress.district }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>{{ presentAddress.thana }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                    <td>{{ presentAddress.address }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Nearby Famous Landmark</td>
                    <td>{{ presentAddress.near_landmark}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>{{ presentAddress.postal_code}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Household Type</td>
                    <td>{{ presentAddress.house_hold_type}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Living in this address</td>
                    <td>{{ presentAddress.living_in_this_address}}</td>
                  </tr>
                </table>
              </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
              <vx-card title="Permanent Address" class="mb-base">
                <table>
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>{{ permanentAddress.pdivision }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>{{ permanentAddress.pdistrict }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>{{ permanentAddress.pthana }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                    <td>{{ permanentAddress.paddress }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Nearby Famous Landmark</td>
                    <td>{{ permanentAddress.pnear_landmark}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>{{ permanentAddress.ppostal_code}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Household Type</td>
                    <td>{{ permanentAddress.phouse_hold_type}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Living in this address</td>
                    <td>{{ permanentAddress.pliving_in_this_address}}</td>
                  </tr>
                </table>
              </vx-card>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button  color="success" class="mr-3 mb-2 float-right" size="small" @click="updateContactInfo(guarantor.id)">Edit Contact Information </vs-button>

            </div>
          </div>
        </vx-card>
        <br>
        <!--      Occupation and dependant-->
        <div class="vx-row">
          <div v-if="occupation !== null" class="vx-col lg:w-1/2 w-full">
            <vx-card title="Occupation Information" class="mb-base">
              <table>
                <tr>
                  <td class="font-semibold">Occupation Type</td>
                  <td>{{ occupation.occupation_type }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Organization Type</td>
                  <td>{{ occupation.occupation }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Monthly Income In BDT</td>
                  <td>{{ occupation.monthly_income }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Name of the Office/Business</td>
                  <td>{{ occupation.name_of_Office_or_business }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Designation</td>
                  <td>{{ occupation.designation}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Job length</td>
                  <td>{{ occupation.job_length}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Division</td>
                  <td>{{ occuAddress.division}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">District</td>
                  <td>{{ occuAddress.district}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thana</td>
                  <td>{{ occuAddress.thana}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Office Area</td>
                  <td>{{ occuAddress.office_area}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                  <td>{{ occuAddress.address}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Postal code</td>
                  <td>{{ occuAddress.postal_code}}</td>
                </tr>
              </table>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button  color="success" class="mr-3 mb-2 float-right" size="small" @click="updateOccupationInfo(guarantor.id)">Edit Occupation Information </vs-button>

                </div>
              </div>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <vx-card v-if="dependent !== null" title="Dependent Information" class="mb-base">
              <table>
                <tr>
                  <td class="font-semibold">No. of Children living with you</td>
                  <td>&nbsp; &nbsp;{{ dependent.number_of_child }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">No. of dependent living with you</td>
                  <td>&nbsp; &nbsp;{{ dependent.number_of_dependent }}</td>
                </tr>
                <br>
              </table>
              <vs-table stripe v-if="dependentDetailsArr !== null"
                        style="max-height: 235px; overflow: scroll; width: 100%">
                <template slot="thead">
                  <vs-th>Relation</vs-th>
                  <vs-th>Name</vs-th>
                  <vs-th>Age</vs-th>
                </template>
                <template>
                  <vs-tr v-for="(dependent, indextr) in dependentDetailsArr" :key="indextr">
                    <vs-td>
                      {{dependent.relation}}
                    </vs-td>
                    <vs-td>
                      {{dependent.name}}
                    </vs-td>
                    <vs-td>
                      {{dependent.age}}
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
              <br>
              <div class="vx-col w-full text-right">
                <vs-button  color="success" class="mr-3 mb-2 float-right" size="small" @click="updateDependentInfo(guarantor.id)">Edit Dependent Information </vs-button>
              </div>
              <br>
            </vx-card>
          </div>
        </div>
        <!-- Showroom and Product  -->

        <br>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        dependentDetailsArr :[],
        guarantor:{},
        personal : '',
        contact: '',
        presentAddress:'',
        permanentAddress:'',
        occupation:'',
        dependent:'',
        occuAddress :'',
        userInfo: {
          name: '',
          phone: '',
          ekyc: {
            parsonal: {},
            contact: {
              permanentAddress: {},
              presentAddress: {}
            },
            occupation: {
              occupationAddress: {}
            },
            dependent: {},
            purchaseInfo: {}
          },
        },
        guarantorId :'',
        ekycId : '',

      }
    },
    apollo: {
      guarantor: {
        query: gql`
         query guarantor($id: ID!){
          guarantor(id:$id){
            id
            name
            phone
            email
            relationship
            status
            ekyc {
              id
              phone
              nid
              email
              status
              parsonal {
                id
                name
                father_name
                mother_name
                spouse_name
                age
                marital_status
                gender
                head_of_household
                education_level
                nid
              }
              contact {
                id
                mobile
                other_phone
                email
                presentAddress {
                  id
                  division
                  district
                  thana
                  address
                  near_landmark
                  postal_code
                  house_hold_type
                  living_in_this_address
                }
                permanentAddress {
                  id
                  pdivision
                  pdistrict
                  pthana
                  paddress
                  pnear_landmark
                  ppostal_code
                  phouse_hold_type
                  pliving_in_this_address
                }
              }
              occupation {
                id
                occupation_type
                occupation
                monthly_income
                name_of_Office_or_business
                designation
                job_length
                occupationAddress {
                  id
                  division
                  district
                  thana
                  office_area
                  address
                  postal_code
                }
              }
              dependent {
                id
                number_of_child
                number_of_dependent
                depandantDetails {
                  id
                  relation
                  name
                  age
                }
              }
            }
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.guarantorId
          }
        },
        update: (data) => data.guarantor
      }

    },
    watch: {
      guarantor (value) {
        this.guarantor = value;
        console.log('GuarantorByID : =', value);
        if(value.ekyc !== null){
          this.ekycId = value.ekyc.id;
          this.userInfo = value.ekyc;
          if(value.ekyc.parsonal !==null){
              this.personal = value.ekyc.parsonal;
          }
          if(value.ekyc.contact !==null){
              this.contact = value.ekyc.contact;
            if(this.contact.presentAddress !== null){
              this.presentAddress = this.contact.presentAddress;
            }
            if(this.contact.permanentAddress !== null){
              this.permanentAddress = this.contact.permanentAddress
            }
          }
          if(value.ekyc.occupation !==null){
              this.occupation = value.ekyc.occupation;
              if(this.occupation.occupationAddress !== null){
                this.occuAddress = this.occupation.occupationAddress;
              }
          }
          if(value.ekyc.dependent !==null){
              this.dependent = value.ekyc.dependent;
              if(this.dependent.depandantDetails !== null){
                this.dependentDetailsArr = this.dependent.depandantDetails;
              }
          }
        }
      }
    },
    methods: {
      updatePersonalInfo(id){
        this.$router.push('/updatePersonalInfo/'+ id +'/'+this.ekycId).catch(() => {});
      },
      updateContactInfo(id){
        this.$router.push('/updateContactInfo/'+ id +'/'+this.ekycId).catch(() => {});
      },
      updateOccupationInfo(id){
        console.log("GID = ", id);
        this.$router.push('/updateOccupation/'+ id +'/'+ this.ekycId).catch(() => {});
      },
      updateDependentInfo(id){
        this.$router.push('/updateDependant/'+ id +'/'+this.ekycId).catch(() => {});
      }
    }
  }
</script>
<style>
  .vx-col table tr > td {
    vertical-align: top;
    min-width: 250px;
    word-break: break-all;
  }

  #page-user-view table td {
    vertical-align: top;
    min-width: 250px;
    word-break: break-all;
  }

  .nav-img-for-gu img {
    height: 55px;
    padding: 5px 0;
  }

  #user-data {
    padding: 15px 30px;
  }
</style>
